import { render, staticRenderFns } from "./BaseLabelWithPackingMode.vue?vue&type=template&id=89eb34e8&scoped=true&"
import script from "./BaseLabelWithPackingMode.vue?vue&type=script&lang=js&"
export * from "./BaseLabelWithPackingMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eb34e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
